var map = {
	"./address_image.svg": 133,
	"./address_image1.svg": 134,
	"./animated_ashutosh.png": 135,
	"./animated_logo.svg": 136,
	"./anthropic_logo.png": 137,
	"./anthropic_logo4.png": 138,
	"./anthropic_logoe.png": 139,
	"./anthropic_logog.png": 140,
	"./aws_logo.png": 141,
	"./aws_logo1.png": 142,
	"./bcg_logo.png": 143,
	"./bcg_logo2.png": 144,
	"./blogs_image.svg": 145,
	"./british_airways_logo.png": 146,
	"./cloud_infrastructure.svg": 147,
	"./codeInLogo.png": 148,
	"./contactMail.png": 149,
	"./coursera_logo.png": 150,
	"./data_science.svg": 151,
	"./datacom_logo.png": 152,
	"./deeplearning_ai_logo.png": 153,
	"./delhivery_logo.png": 154,
	"./deloitte_logo.jpg": 155,
	"./developerActivity.svg": 156,
	"./dsc_logo.png": 157,
	"./education.svg": 158,
	"./esam_profile.jpg": 159,
	"./experience.svg": 160,
	"./feelingProud.svg": 161,
	"./freecopy_logo.png": 162,
	"./fullstack.svg": 163,
	"./gcp_logo.png": 164,
	"./github_logo.png": 165,
	"./googleAssistant.jpg": 166,
	"./googleAssistant.svg": 167,
	"./google_logo.png": 168,
	"./ibm_logo.png": 169,
	"./iiitk_logo.png": 170,
	"./intel_logo.jpg": 171,
	"./jsFramework.svg": 172,
	"./legato_logo.png": 173,
	"./manOnTable.svg": 174,
	"./microsoft_logo.png": 175,
	"./mozilla_logo.png": 176,
	"./muffito_logo.png": 177,
	"./nextuLogo.jpg": 178,
	"./nptel_logo.png": 179,
	"./programmer.svg": 180,
	"./projects_image.svg": 181,
	"./pwa.png": 182,
	"./quantium_logo.jpg": 183,
	"./saayaHealthLogo.png": 184,
	"./stanford_logo.png": 185,
	"./talksCardBack.svg": 186,
	"./talksCardBackAlt.svg": 187,
	"./tata_logo.png": 188,
	"./tiktok_logo.png": 189,
	"./ui_ux_design.svg": 190,
	"./undraw_ai-agent_pdkp.svg": 191,
	"./undraw_ai-data-extraction_soxc.svg": 192,
	"./undraw_all-the-data_ijgn.svg": 193,
	"./undraw_artificial-intelligence_43qa.svg": 194,
	"./undraw_cloudflare-dev_nf79.svg": 195,
	"./undraw_connected-world_anke.svg": 196,
	"./undraw_data-analysis_b7cp.svg": 197,
	"./undraw_data-at-work_3tbf.svg": 198,
	"./undraw_data-processing_ohfw.svg": 199,
	"./undraw_data-reports_l2u3.svg": 200,
	"./undraw_data_25jw.svg": 201,
	"./undraw_design-tools_wgpz.svg": 202,
	"./undraw_developer-activity_4zqd.svg": 203,
	"./undraw_large-language-models_m4no.svg": 204,
	"./undraw_mcp-server_7kvc.svg": 205,
	"./undraw_programming_j1zw.svg": 206,
	"./undraw_real-time-analytics_50za.svg": 207,
	"./watania_university_logo.jpg": 208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;